import './GanttChartLineRenderer.css';
export var svgWrapperCSS = '_mnxak30-3-5-0';